import { render, staticRenderFns } from "./InventoryRequestList.vue?vue&type=template&id=58d0f978&scoped=true&"
import script from "./InventoryRequestList.vue?vue&type=script&lang=js&"
export * from "./InventoryRequestList.vue?vue&type=script&lang=js&"
import style0 from "./InventoryRequestList.vue?vue&type=style&index=0&id=58d0f978&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d0f978",
  null
  
)

export default component.exports